/* ============================================================================
   MÉLIS-MÉLOS GRAVURE-EDITOR — INSTELLINGEN
   ============================================================================
   Dit is de ENIGE plek die je hoeft aan te passen om lettertypes, kleuren en
   ringen te wijzigen. Je hoeft geen andere bestanden aan te raken.

   Regels:
   - Zet achter elke regel een komma, behalve (mag ook) de laatste in een lijst.
   - Kleuren zijn hex-codes zoals #a1b2c3 (te vinden via elke online kleurkiezer).
   - Sla op en ververs de pagina om je wijziging te zien.
   ============================================================================ */

window.MM_CONFIG = {

  /* --------------------------------------------------------------------------
     1) RINGEN (kleurvarianten + foto + graveervlak)
     --------------------------------------------------------------------------
     Elke ring heeft:
       label   = de naam die de klant ziet.
       hex     = het kleurbolletje in de knop (ongeveer de steenkleur).
       src     = pad naar de ringfoto in assets/rings/.
       design  = het ovale graveervlak op de steen: cx,cy = middelpunt,
                 rx,ry = halve breedte/hoogte (in pixels op de 600×600 foto).

     NIEUWE RINGFOTO TOEVOEGEN OF VERVANGEN?
       Meet de ovaal niet met de hand op. Zet de foto in
       assets/rings/_incoming/ en draai:  python3 tools/add-ring.py
       Het script meet het graveervlak automatisch op en geeft je een
       kant-en-klare regel om hieronder te plakken. */
  rings: {
    mint:      { label: 'Mint groen',    hex: '#cfe3d0', src: 'assets/rings/mint-signet.png',      design: { cx: 308, cy: 358, rx: 66, ry: 75 } },
    yellow:    { label: 'Butter yellow', hex: '#edc976', src: 'assets/rings/yellow-signet.png',    design: { cx: 310, cy: 356, rx: 85, ry: 99 } },
    purple:    { label: 'Deep purple',   hex: '#7d5aa6', src: 'assets/rings/purple-signet.png',    design: { cx: 313, cy: 344, rx: 63, ry: 73 } },
    pink:      { label: 'Pink',          hex: '#e19cbf', src: 'assets/rings/pink-signet.png',      design: { cx: 322, cy: 340, rx: 67, ry: 73 } },
    red:       { label: 'Red',           hex: '#e2352a', src: 'assets/rings/red-signet.png',       design: { cx: 311, cy: 362, rx: 65, ry: 72 } },
    lightblue: { label: 'Light blue',    hex: '#8fbdd9', src: 'assets/rings/lightblue-signet.png', design: { cx: 309, cy: 358, rx: 73, ry: 83 } },
    blue:      { label: 'Blue',          hex: '#2a3f8f', src: 'assets/rings/blue-signet.png',      design: { cx: 308, cy: 358, rx: 74, ry: 83 } },

    /* LIMA (grotere zus van JOOSJE) + NYGS — aparte modellen, elk een eigen foto. */
    'lima-blue':  { label: 'LIMA blue',  hex: '#8a9aa0', src: 'assets/rings/lima-blue.png',  design: { cx: 318, cy: 316, rx: 73, ry: 80 } },
    'lima-red':   { label: 'LIMA red',   hex: '#be1f57', src: 'assets/rings/lima-red.png',   design: { cx: 320, cy: 313, rx: 79, ry: 85 } },
    'lima-white': { label: 'LIMA white', hex: '#d9d2c7', src: 'assets/rings/lima-white.png', design: { cx: 313, cy: 331, rx: 61, ry: 68 } },
    'nygs':       { label: 'NYGS lapis', hex: '#16277a', src: 'assets/rings/nygs.png',       design: { cx: 318, cy: 362, rx: 70, ry: 82 } }
  },

  /* --------------------------------------------------------------------------
     2) LETTERTYPES (van sierlijk tot arty)
     --------------------------------------------------------------------------
     Elk lettertype heeft:
       label  = de naam in het keuzemenu.
       css    = de exacte font-familienaam (meestal gelijk aan label).
       google = het stukje uit de Google Fonts-link. Het lettertype wordt
                hiermee automatisch geladen — je hoeft index.html NIET te wijzigen.

     LETTERTYPE TOEVOEGEN?
       1. Zoek het font op https://fonts.google.com
       2. Klik "Get font" → "Get embed code". In de <link> zie je iets als
          family=Poppins:wght@400;600  — dat hele stuk na "family=" is je 'google'.
       3. Voeg hieronder een regel toe. De eerste in de lijst is het standaard-
          lettertype waarmee de editor opent.

     (Contralto is een betaald font en staat er voorlopig uit; zodra we het
      bestand hebben, voegen we het hier toe.) */
  fonts: [
    { label: 'Bodoni Moda',        css: 'Bodoni Moda',        google: 'Bodoni+Moda:opsz,wght@6..96,400;6..96,600' },
    { label: 'Cormorant Garamond', css: 'Cormorant Garamond', google: 'Cormorant+Garamond:wght@400;600' },
    { label: 'Playfair Display',   css: 'Playfair Display',   google: 'Playfair+Display:wght@400;600' },
    { label: 'Cinzel',             css: 'Cinzel',             google: 'Cinzel:wght@400;600' },
    { label: 'Libre Franklin',     css: 'Libre Franklin',     google: 'Libre+Franklin:wght@300;400;600' },
    { label: 'Dancing Script',     css: 'Dancing Script',     google: 'Dancing+Script:wght@400;600' },
    { label: 'Parisienne',         css: 'Parisienne',         google: 'Parisienne' },
    { label: 'Great Vibes',        css: 'Great Vibes',        google: 'Great+Vibes' },
    { label: 'La Belle Aurore',    css: 'La Belle Aurore',    google: 'La+Belle+Aurore' },
    { label: 'Abril Fatface',      css: 'Abril Fatface',      google: 'Abril+Fatface' }
  ],

  /* --------------------------------------------------------------------------
     3) GRAVEERKLEUREN
     --------------------------------------------------------------------------
     Elke kleur heeft:
       name = de naam. LET OP: deze moet exact gelijk zijn aan de optiewaarde
              in Shopify, anders klopt de bestelling straks niet.
       hex  = de kleur van het bolletje én van de gravering in de preview.

     KLEUR TOEVOEGEN? Voeg gewoon een regel toe. Volgorde = volgorde in de tool. */
  colors: [
    { name: 'White',       hex: '#ffffff' },
    { name: 'Grey',        hex: '#9a9a9a' },
    { name: 'Black',       hex: '#1a1a1a' },
    { name: 'Gold',        hex: '#c6a24c' },
    { name: 'Lila',        hex: '#b9a0d4' },
    { name: 'Light Blue',  hex: '#6fb2dd' },
    { name: 'Dark Blue',   hex: '#1a2f66' },
    { name: 'Ice Blue',    hex: '#c3deea' },
    { name: 'Red',         hex: '#d62828' },
    { name: 'Bordeaux',    hex: '#6e1420' },
    { name: 'Dark Green',  hex: '#234b34' },
    { name: 'Neon Yellow', hex: '#e9f500' },
    { name: 'Neon Orange', hex: '#ff6a00' },
    { name: 'Neon Green',  hex: '#4de94c' },
    { name: 'Neon Pink',   hex: '#ff3e9a' }
  ]
};
